import getAllTableViewsContainingItemsForFolder from './getAllTableViewsContainingItemsForFolder';
import getAllTableViewsContainingItemsForGroup from './getAllTableViewsContainingItemsForGroup';
import { MailboxInfo, MailboxType } from 'owa-client-ids';
import TableView from 'owa-mail-list-store/lib/store/schema/TableView';

/**
 * Get all the table views that may contain items given the information passed in
 * @param mailboxInfo the mailbox info of the item
 * @param parentFolderId the parent folder id for the item
 * @param shouldIncludeSearchTable - whether to include the search table in the table list being returned
 */
export default function getAllTableViewsContainingItems(
    mailboxInfo: MailboxInfo,
    parentFolderId: string,
    shouldIncludeSearchTable: boolean
): TableView[] {
    let tableViews: TableView[] = [];
    if (mailboxInfo && mailboxInfo.type == MailboxType.GroupMailbox) {
        tableViews = getAllTableViewsContainingItemsForGroup(
            mailboxInfo.deprecatedMailboxId,
            shouldIncludeSearchTable
        );
    } else {
        tableViews = getAllTableViewsContainingItemsForFolder(
            parentFolderId,
            shouldIncludeSearchTable
        );
    }

    return tableViews;
}
